
/* INQUIRY */
export const GET_INQUIRY_LISTING = "GET_INQUIRY_LISTING";
export const GET_INQUIRY_LISTING_SUCCESS = "GET_INQUIRY_LISTING_SUCCESS";
export const GET_INQUIRY_LISTING_FAIL = "GET_INQUIRY_LISTING_FAIL";

export const GET_INQUIRY_DETAILS = "GET_INQUIRY_DETAILS";
export const GET_INQUIRY_DETAILS_SUCCESS = "GET_INQUIRY_DETAILS_SUCCESS";
export const GET_INQUIRY_DETAILS_FAIL = "GET_INQUIRY_DETAILS_FAIL";

export const ADD_INQUIRY = "ADD_INQUIRY";
export const ADD_INQUIRY_SUCCESS = "ADD_INQUIRY_SUCCESS";
export const ADD_INQUIRY_FAIL = "ADD_INQUIRY_FAIL";

export const UPDATE_INQUIRY = "UPDATE_INQUIRY";
export const UPDATE_INQUIRY_SUCCESS = "UPDATE_INQUIRY_SUCCESS";
export const UPDATE_INQUIRY_FAIL = "UPDATE_INQUIRY_FAIL";

export const DELETE_INQUIRY = "DELETE_INQUIRY";
export const DELETE_INQUIRY_SUCCESS = "DELETE_INQUIRY_SUCCESS";
export const DELETE_INQUIRY_FAIL = "DELETE_INQUIRY_FAIL";

export const DETAILS_LISTING_INQUIRY = "DETAILS_LISTING_INQUIRY";
export const DETAILS_LISTING_INQUIRY_SUCCESS = "DETAILS_LISTING_INQUIRY_SUCCESS";
export const DETAILS_LISTING_INQUIRY_FAIL = "DETAILS_LISTING_INQUIRY_FAIL";

export const RESET_INQUIRY_STATE = 'RESET_INQUIRY_STATE';
export const RESET_INQUIRY_ATTACHMENT_STATE = 'RESET_INQUIRY_ATTACHMENT_STATE';